export default __webpack_public_path__ + "static/media/scout_on_ipad.58d7208b.jpg";